import { computedFrom, autoinject, observable } from "aurelia-framework";
import { Router, Redirect, activationStrategy } from 'aurelia-router';

import { BusyService } from "../services/busy-service";
import { WebApiService } from "../services/web-api-service";
import { AppMessageService } from "../services/app-message-service";
import { SecurityService } from "../services/security-service";
import { Globals } from "../models/globals";
import { DialogService } from "aurelia-dialog";
import { ExecutiveDashboardDetailsDialog } from "./dialogs/executive-dashboard-details-dialog";

@autoinject()
export class ExecutiveDashboard {

    entityTypes: { id: string; description: string; }[];


    @observable()
    selectedEntityType = "";
    isAttached: boolean;
    selectedEntityTypeChanged() {
        this.loadDashboardCarriersStatus();
        this.loadDashboardProcessDuration();
    }

    millCodes: Array<string> = [];

    @observable()
    isAllEntityTypesSelected: boolean;

    constructor(
        private securityService: SecurityService,
        private dialogService: DialogService,
        private busyService: BusyService,
        private api: WebApiService) {

        this.entityTypes = new Globals().getEntityTypes();
    }

    activate() {
        this.currentMillCode = this.securityService.user.millCodes[0];
        this.loadMills();
    }

    attached() {
        var stuff = (<any>$(".status-info-button"));
        stuff.popover();
        this.isAttached = true;

        this.loadDashboardCarriersStatus();
        this.loadDashboardProcessDuration();

    }


    loadMills() {
        this.busyService.on();
        return this.api.get("Registration", "GetDivisions")
            .then((result) => {
                let response = JSON.parse(result.response);
                this.millCodes = response.map((item) => {
                    return item.code;
                }).filter(millCode => {
                    if (this.securityService.user.millCodes.length == 0)
                        return true;
                    else
                        return this.securityService.user.millCodes.find(o => o == millCode);
                });
            })
            .finally(() => {
                this.busyService.off();
            });
    }


    @observable()
    currentMillCode: string;
    currentMillCodeChanged() {
        this.loadDashboardCarriersStatus();
        this.loadDashboardProcessDuration();
    }


    carrierStatusInfo: any;
    processDurationInfo: any;

    @observable()
    selectedProcessDurationPeriod: string = "WeekToDate";

    selectedProcessDurationPeriodChanged() {
        this.loadDashboardProcessDuration();
    }

    calculatePercentOfTotal(part, total) {
        if (total > 0) {
            return Math.round((part / total) * 100);
        }
    }

    loadDashboardCarriersStatus() {
        if (!this.isAttached) return;

        this.busyService.on();
        let millCode = this.currentMillCode;
        return this.api.get("Reports", "GetExecutiveDashboardCarriersStatus", { millCode: millCode, entityType: this.selectedEntityType })
            .then((result) => {
                var data = JSON.parse(result.response);
                this.carrierStatusInfo = data;
            })
            .finally(() => {
                this.busyService.off();
            });
    }

    loadDashboardProcessDuration() {
        if (!this.isAttached) return;

        this.busyService.on();
        return this.api.get("Reports", "GetExecutiveDashboardProcessDuration", { period: this.selectedProcessDurationPeriod, millCode: this.currentMillCode, entityType: this.selectedEntityType })
            .then((result) => {
                var data = JSON.parse(result.response);
                this.processDurationInfo = data;
            })
            .finally(() => {
                this.busyService.off();
            });
    }

    viewDetails() {

        this.dialogService.open(
            {
                viewModel: ExecutiveDashboardDetailsDialog,
                model: { period: this.selectedProcessDurationPeriod, millCode: this.currentMillCode, entityType: this.selectedEntityType }
            });
    }


}
